import styled from 'styled-components'
import { ResultJobsEvaluationsDto } from '../../../models/Dto/ResultJobsEvaluationsDto'
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { useEffect, useState } from 'react'

type Props = {
  resultJobsEvaluationsDtos: ResultJobsEvaluationsDto[]
  activeIndex: number
}

type Data = {
  name: string
  구체성: number
  흥미성: number
  사회적필요성: number
}

function ResultGraph(props: Props) {
  const [data, setData] = useState<Data[]>([])

  useEffect(() => {
    const d = props.resultJobsEvaluationsDtos.map((r) => {
      const c = r.resultJobsEvaluations.reduce(
        (acc, curr) => acc + curr.concreteness,
        0
      )
      const i = r.resultJobsEvaluations.reduce(
        (acc, curr) => acc + curr.interest,
        0
      )
      const n = r.resultJobsEvaluations.reduce(
        (acc, curr) => acc + curr.need,
        0
      )

      return {
        name: r.resultJobs.jobName,
        구체성: c,
        흥미성: i,
        사회적필요성: n,
        total: c + i + n,
      }
    })
    console.log('data', d)

    setData(d)
  }, [props.resultJobsEvaluationsDtos])

  return (
    <Container>
      <BarChart
        width={1200}
        height={700}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3 " />
        <XAxis dataKey="name" height={70} orientation="bottom" />
        <YAxis />
        <Tooltip />
        <Legend />
        {(props.activeIndex === 0 || props.activeIndex === 1) && (
          <Bar dataKey="구체성" stackId="a" fill="#8884d8">
            {props.activeIndex === 0 ? (
              <LabelList dataKey="total" position="top" />
            ) : (
              <LabelList dataKey="구체성" position="top" />
            )}
          </Bar>
        )}
        {(props.activeIndex === 0 || props.activeIndex === 2) && (
          <Bar dataKey="흥미성" stackId="a" fill="#d8b449">
            {props.activeIndex === 0 ? (
              <LabelList dataKey="total" position="top" />
            ) : (
              <LabelList dataKey="흥미성" position="top" />
            )}
          </Bar>
        )}
        {(props.activeIndex === 0 || props.activeIndex === 3) && (
          <Bar dataKey="사회적필요성" stackId="a" fill="#2bd044">
            {props.activeIndex === 0 ? (
              <LabelList dataKey="total" position="top" />
            ) : (
              <LabelList dataKey="사회적필요성" position="top" />
            )}
          </Bar>
        )}
      </BarChart>
    </Container>
  )
}

const Container = styled.div`
  margin: 20px auto;
  width: 1200px;
`

export default ResultGraph
